/** Identifica a empresa antes do login sem consultar cadastros privados no navegador. */
import { useQuery } from '@tanstack/react-query';
import { callProviderPortal } from '@/lib/providerPortal';

export function useProviderPortalPresentation(tenantSlug: string) {
  return useQuery({
    queryKey: ['pp-public', tenantSlug, 'presentation'],
    queryFn: () => callProviderPortal<{ tenant: { name: string } }>(tenantSlug, 'portal.info'),
    staleTime: 5 * 60_000,
    retry: false,
  });
}